import {
  LoanEditorActionsEnum,
  MersDeactivationKind,
  mersDeactivationKindOptions,
  mersKindOptionsByActionType,
  MersRegistrationKind,
  MersTransferKind,
} from 'constants/loanActionEditor';

import { LoanEditorItemsKeyByType } from '../LoanActionsGroup.utils';

// An automated run has no one to enter a liquidation date, so it can only send a Transfer to Non-MERS.
const automatedDeactivationKindOptions = mersDeactivationKindOptions.filter(
  ({ value }) => value === MersDeactivationKind.TRANSFER_TO_NON_MERS,
);

const MERS_ROW_CONFIGS = {
  [LoanEditorActionsEnum.REGISTER_WITH_MERS]: {
    kindLabel: 'Registration type',
    toggle: {
      fieldName: 'preClosing',
      label: 'Register before closing (no note date yet)',
      kinds: [MersRegistrationKind.I_REGISTRATION],
    },
  },
  [LoanEditorActionsEnum.DEACTIVATE_MERS_MIN]: {
    kindLabel: 'Deactivation type',
    automatedKindOptions: automatedDeactivationKindOptions,
  },
  [LoanEditorActionsEnum.REVERSE_MERS_DEACTIVATION]: {
    kindLabel: 'Deactivation to reverse',
  },
  [LoanEditorActionsEnum.TRANSFER_WITH_MERS]: {
    kindLabel: 'Transfer type',
    toggle: {
      fieldName: 'flow',
      label: 'Flow transfer (off for a seasoned transfer)',
      kinds: [MersTransferKind.SERVICING_RIGHTS],
    },
  },
};

export const getMersRowConfig = (itemType, isAutomatedActions) => {
  const config = MERS_ROW_CONFIGS[itemType];

  if (!config) {
    return null;
  }

  return {
    ...config,
    formKey: LoanEditorItemsKeyByType[itemType],
    kindOptions:
      (isAutomatedActions && config.automatedKindOptions) || mersKindOptionsByActionType[itemType],
  };
};
